import React from 'react';
import { connect } from 'react-redux';
import styles from '../Dashboards.mod.less';
import Spinner from '../../common/Spinner';
import { useAhaPanelContents, useHtmlSnapshot } from '../hooks';
import AhaContents from './AhaContents';
import customElementBoolAttr from 'javascripts/util/customElementBoolAttr';

/**
 * @typedef NowNextLaterProps
 * @prop {*=} panel
 * @prop {*=} preview
 * @prop {*=} style
 * @prop {*=} bookmarkId
 * @prop {*=} filters
 */
/**
 * @type {React.FC<NowNextLaterProps>}
 */
const NowNextLater = ({ panel, preview, style, bookmarkId, filters }) => {
  const shouldUseHtmlSnapshot = useHtmlSnapshot();
  const ahaContents = useAhaPanelContents({
    panel,
    bookmarkId,
    preview,
    filters,
    showLegend: panel.showLegend,
    dashboardFilter: panel.dashboardFilter,
  });

  let panelContent;
  if (ahaContents || shouldUseHtmlSnapshot) {
    panelContent = <AhaContents ahaContents={ahaContents} />;
  } else {
    panelContent = <Spinner />;
  }

  const isLoading = !ahaContents && !shouldUseHtmlSnapshot;

  return (
    <div
      className={styles.PanelContent}
      aria-label='Now, Next, Later roadmap'
      data-async-loading={customElementBoolAttr(isLoading)}
    >
      {panelContent}
    </div>
  );
};

const mapStateToProps = state => ({
  bookmarkId: state.getIn(['meta', 'bookmarkId']),
  filters: state.getIn(['meta', 'filters']),
});

export default connect(mapStateToProps)(NowNextLater);
